import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FilePreviewService {
  private baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  previewImage(fileUrl: string) {
    const url = `${this.baseUrl}/vendor/leave-attachment?fileUrl=${fileUrl}`;
    return this.http.get(url, {
      responseType: 'blob',
    });
  }
}
